// Note: not currently being used since we're using the embed, but keeping in case we revert to using the API
class HHNewsletterSignup extends HTMLElement {
  constructor() {
    super()

    this.form = this.querySelector('form')
    if (!this.form) return

    this.form.addEventListener('submit', this.submitForm.bind(this))

    this.klaviyoCompanyId = this.form.querySelector(
      '[name="klaviyo-company-id"]'
    ).value
    this.klaviyoListId = this.form.querySelector(
      '[name="klaviyo-list-id"]'
    ).value

    this.submitButton = this.querySelector('[type="submit"]')
    this.successBanner = this.querySelector('.js-success-banner')
    this.errorBanner = this.querySelector('.js-error-banner')
  }

  submitForm(evt) {
    evt.preventDefault()
    this.hideStatus()
    this.submitButton?.setAttribute('disabled', true)
    if (!this.klaviyoCompanyId || !this.klaviyoListId) {
      this.adminError()
    }

    const formData = new FormData(this.form)
    const email = formData.get('contact[email]')
    this.createSubscription(email)
  }

  async createSubscription(email) {
    window.dataLayer = window.dataLayer || []
    const url = `https://a.klaviyo.com/client/subscriptions/?company_id=${this.klaviyoCompanyId}`

    const options = {
      method: 'POST',
      headers: { revision: '2023-06-15', 'content-type': 'application/json' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            list_id: this.klaviyoListId,
            custom_source: 'Footer signup form',
            email: email,
          },
        },
      }),
    }

    try {
      const res = await fetch(url, options)
      if (!res.ok) throw new Error('Klaviyo API error')

      const emailInput = this.form.querySelector('input[name="contact[email]"]')
      emailInput.value = ''
      const inputWrapper = this.form.querySelector('hh-input-wrapper')
      inputWrapper.removeAttribute('filled')

      this.showSuccess()

      setTimeout(() => {
        this.hideStatus()
      }, 5000)
    } catch (error) {
      console.error(error)
      this.showError()
    } finally {
      this.submitButton?.removeAttribute('disabled')
    }
  }

  adminError() {
    console.error(
      'Klaviyo Company ID or List ID not set in theme editor settings'
    )
    this.submitButton.setAttribute('disabled', true)
    this.showError()
  }

  showSuccess() {
    this.successBanner?.removeAttribute('hidden')
  }

  showError() {
    this.errorBanner?.removeAttribute('hidden')
  }

  hideStatus() {
    this.successBanner?.setAttribute('hidden', true)
    this.errorBanner?.setAttribute('hidden', true)
  }
}

customElements.define('hh-newsletter-signup', HHNewsletterSignup)
